"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var StyleFunctions_1 = require("./StyleFunctions");
var VizPortalStyles_1 = require("./VizPortalStyles");
exports.FilterPanelCheckbox = StyleFunctions_1.cssClass('filterPanelCheckboxClass', {
    float: 'right',
    paddingBottom: '20px'
});
exports.FilterPanelDropdown = StyleFunctions_1.cssClass('filterPanelDropdownClass', {
    float: 'right',
    paddingBottom: '20px'
});
exports.FilterPanelDropdownButton = StyleFunctions_1.cssClass('filterPanelDropdownButtonClass', {
    float: 'right',
    // Set a large enough width until tfsid904298 is fixed from shared widget
    width: '220px'
});
exports.FilterPanelDropdownListBox = StyleFunctions_1.cssClass('filterPanelDropdownListbox', {
    maxHeight: '240px',
    overflowY: 'auto'
});
exports.FilterPanelDropdownLabel = StyleFunctions_1.cssClass('filterPanelDropdownLabelClass', __assign({}, VizPortalStyles_1.vizPortalFontStyle, { color: widgets_1.TabStyles.Typography.Color.Secondary, fontSize: widgets_1.TabStyles.Typography.Sizing.Default, lineHeight: '24px', paddingRight: widgets_1.TabStyles.Spacing.SmallSpace }));
exports.FilterPanelDropdownItem = StyleFunctions_1.cssClass('filterPanelDropdownItemCount', {
    display: 'flex'
});
exports.FilterPanelDropdownItemCount = StyleFunctions_1.cssClass('filterPanelDropdownItemCount', {
    marginLeft: 'auto'
});
exports.FilterPanelToolBar = StyleFunctions_1.cssClass('filterPanelToolBarClass', {
    paddingBottom: '16px',
    paddingLeft: '10px',
    paddingRight: '10px',
    minWidth: '220px',
    overflow: 'hidden',
    transition: 'right .3s ease-in-out',
    borderLeft: "1px solid " + widgets_1.TabStyles.Colors.L9Disabled
});
exports.FilterPanelToolBarStackingRoot = StyleFunctions_1.cssClass('filterPanelStackingRootClass', {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    paddingTop: '20px'
});
exports.FilterPanelToggleButtonStyle = {
    display: 'block'
};
//# sourceMappingURL=FilterPanelStyles.js.map